export default "__VITE_ASSET__Bhfw4KJE__"